import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "src/environments/environment";
import { WalletResponseDto } from "../dto/response/wallet-response-dto";

@Injectable({
  providedIn: "root"})
export class WalletService {
  constructor(private _httpClient: HttpClient) {}

  getWallets(): Observable<WalletResponseDto[]> {
    return this._httpClient.get<WalletResponseDto[]>(
      `${environment.backend}/wallets`
    );
  }
}
